import { API_BASE_URL } from './api.js';

export async function fetchCategoryBySlug(slug) {
  const response = await fetch(`${API_BASE_URL}/categories?slug=${slug}`);
  if (!response.ok) throw new Error('Error fetching category');
  return await response.json();
}

export async function fetchCategories() {
  const response = await fetch(`${API_BASE_URL}/categories`);
  if (!response.ok) throw new Error('Error fetching categories');
  return await response.json();
}